const styles = (theme) => ({
  border: {
    borderBottom: `1px solid ${theme.color.grey_ed}`,
  },

  clientName: {
    fontSize: 20,
    color: theme.color.black,
    marginBottom: 16,
  },

  key: {
    paddingRight: 16,
    color: theme.color.grey_75,
    fontSize: 14,
    letterSpacing: 1,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    verticalAlign: 'top',
    width: 25,
  },
  keyNew: {
    padding: theme.spacing(0.6, 5, 0.6, 0),
  },
  keyReservation: {
    color: theme.color.black_54,
    letterSpacing: 1.4,
  },
  list: {
    flex: 1,
  },
  listLine: {
    padding: theme.spacing(3, 0, 3),
  },

  value: {
    color: theme.color.black_33,
    fontSize: 16,
    lineHeight: 1,
  },

  span: {
    verticalAlign: 'middle',
  },

  link: {
    color: theme.color.green_7c,
    cursor: 'pointer',
  },

  badge: {
    background: theme.color.beige_84,
    color: theme.color.white,
    fontSize: 11,
    marginLeft: 5,
    borderRadius: 1,
    padding: theme.spacing(1, 4),
    verticalAlign: 'middle',
  },

  action: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(0, 0.5),
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
  },

  orderCard: {
    padding: 34,
    display: 'flex',
  },

  orderCardExp: {
    padding: theme.spacing(1, 4, 4, 4),
  },
  orderCardReservation: {
    padding: theme.spacing(0, 3, 2.5, 2.5),
  },
  hasError: {
    background: theme.color.pink_light,
    boxShadow: `inset 8px 0 0px -3px ${theme.color.red_dark}`,
    border: 0,
    marginTop: -1,
  },

  negativePrice: {
    color: theme.color.red_00,
  },

  preSaleContainer: {
    paddingBottom: theme.spacing(0.5),
    display: 'grid',
  },
  preSales: {
    paddingTop: theme.spacing(0.5),
  },
});

export default styles;
